import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-choose-us',
  templateUrl: './why-choose-us.component.html',
  styleUrls: ['./why-choose-us.component.scss']
})
export class WhyChooseUsComponent implements OnInit {

  features = [
    {
      title: 'Best Infrastructure',
      icon: 'fas fa-building-columns',
      desc: 'The infrastructure and facility available on campus are amongst the very best. It is a wholly self-contained campus comprising of everything that students on campus would ever require. Come; see it to believe it.'
    },
    {
      title: 'Modern Library',
      icon: 'fas fa-book-open',
      desc: 'The objective of a college library is to supplement the instructions imparted in the classroom. It aims to function as an independent teaching agency, encouraging and promoting the use of books.'
    },
    {
      title: 'Experienced Faculty',
      icon: 'fas fa-chalkboard-user',
      desc: 'The quality of the academic staff is decisive for the quality of the college. At VGC College, Samalkha the members of the academic staff come from accomplished backgrounds with vast experience in the field of education.'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
